module.exports = __webpack_public_path__ + "static/media/Best-Mobile-App-Initiative-at-NBFC-Awards.42bec5e9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Best-Mobile-App-Initiative-at-NBFC-Awards.jpeg
// module id = 345
// module chunks = 0